import aleisterBadge from "src/assets/images/knight/special/aleister/rank.png";
import aleisterBg from "src/assets/images/knight/special/aleister/part.gif";
import aleisterBgFull from "src/assets/images/knight/special/aleister/full.gif";
import aleisterNoBg from "src/assets/images/knight/special/aleister/knight.png";

import johannaBadge from "src/assets/images/knight/special/johanna/rank.png";
import johannaBg from "src/assets/images/knight/special/johanna/part.gif";
import johannaBgFull from "src/assets/images/knight/special/johanna/full.gif";
import johannaNoBg from "src/assets/images/knight/special/johanna/knight.png";

import techfiBadge from "src/assets/images/knight/special/techfi/rank.png";
import techfiBg from "src/assets/images/knight/special/techfi/part.gif";
import techfiBgFull from "src/assets/images/knight/special/techfi/full.gif";
import techfiNoBg from "src/assets/images/knight/special/techfi/knight.png";

import noelBadge from "src/assets/images/knight/special/noel/rank.png";
import noelBgFull from "src/assets/images/knight/special/noel/full.png";
import noelNoBg from "src/assets/images/knight/special/noel/knight.png";

import todBadge from "src/assets/images/knight/special/tod/rank.png";
import todBg from "src/assets/images/knight/special/tod/part.gif";
import todBgFull from "src/assets/images/knight/special/tod/full.gif";
import todNoBg from "src/assets/images/knight/special/tod/knight.png";

export const fakeSpecialCollectionIdList = [123123, 220203, 222605, 222406, 222607];
export const fakeSpecialCollectionAssetsMapping = {
  123123: {
    id: 123123,
    name: "TR-A Valor-1",
    img: noelNoBg,
    imgBg: noelBgFull,
    badge: noelBadge,
    palette: {
      primary: "#c74b4b",
    },
    pin: true,
    rarity: "limited",
    theme: "noel",
    description: `An ancient war machina unearthed from the ruins of the Southern Empty. Since its discovery, it has piqued the interests of Trava Kingdom’s Convocation of the Polytechnicians – where gathers the greatest minds in the kingdom.\n
      Not only are its inner workings completely strange, but its outer coat also poses serious questions with red and green stripes. Nevertheless, historians have agreed that the colours represent traditions of the distant past, most probably some sort of winter holiday.\n
      After months of analyzing and scrutinizing TR-A Valor-1, scientists of the Trava Kingdom have successfully activated and assumed complete control over the machina, deeming it combat ready to stand against the dragons - though they still wonder what Jingle Bells means every time the war machina boots up.
      `,
    set: "legendary",
  },
  220203: {
    id: 220203,
    name: "Sir Kuana of TraDAO",
    fullName: "Sir Kuana, Commander of TraDAO",
    img: todNoBg,
    imgBg: todBg,
    imgLarge: todBgFull,
    badge: todBadge,
    palette: {
      primary: "#c74b4b",
    },
    pin: true,
    rarity: "limited",
    theme: "fallingStar",
    description: `Of all the things that are symbolic of the Trava Kingdom during the hundred year Draconic War, few are as iconic as the Order of TraDAO.\n
      TraDAO Knights - a selection of only the best Knights ever dawned upon the Kingdom - are specialized in aerial combat, and all have shed their heavy armors to adapt an extremely lightweight version forged with stellarium ore, trading off defense for the ability to soar and battle the dragons right on their home field: the vast sky.\n
      Currently, the Commander of the Order is Sir Kuana Audovera, Knight Commander of Trava Kingdom. Having slain countless lesser dragons and survived confrontation with two Elder Wyrms himself, Sir Kuana proves to be a legend among legends, a man who younglings of Trava Kingdom idolize and strive to become. But inside his heart, a fire of hatred and despair rages still, for he has not found Tryss the Blazing Elder Wyrm, who killed his wife and son fifteen years ago, and yet he walks on, ever on the path of vengeance.
      `,
    set: "legendary",
    price: 2500000,
    type: "unique",
  },
  222605: {
    id: 222605,
    name: "Dame Johanna",
    fullName: "Dame Johanna, Shield of the Twelve",
    img: johannaNoBg,
    imgBg: johannaBg,
    imgLarge: johannaBgFull,
    badge: johannaBadge,
    palette: {
      primary: "#c74b4b",
    },
    pin: true,
    rarity: "limited",
    theme: "fallingStar",
    description: `'I am thy shield, my liege, for now and forevermore.'\n
      Johanna was born to a family of knighthood, and was raised along with swords and shields. Then the Draconic War came, and her parents, a Knight Officer and a Healer, perished in the Battle of Iorela. She was then given a conviction: to serve in the Holy Knight Order, to protect the Kingdom… and her little brother.\n
      Bearing that conviction, she trained and trained, and with exceptional talents, she graduated as the top of the Royal Knight Academy. Through battles and battles, she proved to be a master of the shield, using it to stop every attack launched at her and her comrades. Acknowledging her skills, King Svitanae personally appointed her into the Twelve, the council of the strongest Knights of Trava Kingdom, and she held the seat of The Shield, whose primary job is to guard King Svitanae from the unforeseen forces.\n
      Thus, the legend of Dame Johanna, Shield of the Twelve, a woman with unparalleled beauty but incredible fierceness, was born.`,
    set: "legendary",
    price: 3000000,
    type: "unique",
  },
  222406: {
    id: 222406,
    name: "Aleister",
    fullName: "Aleister, Eye of the Twelve",
    img: aleisterNoBg,
    imgBg: aleisterBg,
    imgLarge: aleisterBgFull,
    badge: aleisterBadge,
    palette: {
      primary: "#c74b4b",
    },
    pin: true,
    rarity: "limited",
    theme: "fallingStar",
    description: `Before the Draconic War, King Svitanae had searched for a specific individual, a person of incredible intelligence that was capable of deciphering the Book of DAO, a sacred book that could even change the foundation of Trava Kingdom itself.\n
      This individual was called Aleister, a young lad hailed from the remote village on the Island of Costa del Paraiso. In pursuit of knowledge, he set out on a journey, from the borders of Iorela to the forbidden library in Hollowbane, where he met King Svitanae. \n“Duel with me for a match of chess.” - King Svitanae offered. After a fierce battle that lasted two hours, Aleister emerged victorious.\n
      “Thou lose, old man.”\n
      “Thy talent is indisputable, young lad. Want a spot in The Twelve?”\n
      “Are there books there?”\n
      “The Royal Library has plenty.”\n
      Thus, Aleister joined The Twelve, the council of the strongest Knights of Trava Kingdom, albeit not exactly a Knight yet himself. \n
      The legend of Aleister, Eye of the Twelve, was thus born, a young man with the eye of azure, holder of the Book of DAO, who secretly steered the Trava Kingdom and the very course of history from the shadows.`,
    set: "legendary",
    price: 3000000,
    type: "unique",
  },
  222607: {
    id: 222607,
    name: "Medivh",
    fullName: "Medivh, Ambassador of Techfian Principality",
    img: techfiNoBg,
    imgBg: techfiBg,
    imgLarge: techfiBgFull,
    badge: techfiBadge,
    palette: {
      primary: "#c74b4b",
    },
    pin: true,
    rarity: "limited",
    theme: "fallingStar",
    description: `Techfian Principality was a small nation that existed in the far east of the Crypto World, renowned by their impressive records of history of Crypto World, as well as the fundamental understanding of how Crypto World functioned.\n
      Seeking knowledge, King Svitanae had visited Techfian Principality on various occasions, at times indulged himself into the Central Library, the largest library containing every discovered fact of Crypto World, at times admired the beautiful scenery and the hospitality of Techfians.\n
      Having heard that Trava Kingdom was in grave danger posed by Dragons of the North, Crown Prince of Techfian had sent Medivh of Belfalas, head of the Central Library, a sage of incredible erudition to Trava Kingdom.\n
      Medivh's job was not to participate in direct combat, but to enlighten Trava people, providing them crucial knowledge about the Crypto World, and with his wisdom, citizens of Trava Kingdom would have yet another weapon to defeat the wicked dragons.\n`,
    set: "legendary",
    price: 3000000,
    type: "unique",
  },
};
